import { useCallback, useState } from "react";

export type UseDismissedTooltipType = {
  storageKey: string;
  defaultDismissed?: boolean;
};

export function useDismissedTooltip({ storageKey, defaultDismissed = false }: UseDismissedTooltipType) {
  const [isDismissedTooltip, setIsDismissedTooltip] = useState(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored === "true" || defaultDismissed;
    } catch (error) {
      return defaultDismissed;
    }
  });

  const handleDismissedTooltip = useCallback(() => {
    try {
      localStorage.setItem(storageKey, "true");
      setIsDismissedTooltip(true);
    } catch (error) {
      setIsDismissedTooltip(true);
    }
  }, [storageKey]);

  const handleResetDismissedTooltip = useCallback(() => {
    try {
      localStorage.removeItem(storageKey);
      setIsDismissedTooltip(false);
    } catch (error) {
      setIsDismissedTooltip(false);
    }
  }, [storageKey]);

  return {
    isDismissedTooltip,
    handleDismissedTooltip,
    handleResetDismissedTooltip,
  };
}
